import { ReactNode } from "react";

import { cx } from "class-variance-authority";

import * as theme from "./ApplicationBarToolbar.css";
import { useApplicationBarVariant } from "./ApplicationBarVariant";

export interface ApplicationBarToolbarProps {
    actions?: ReactNode;
    /**
     * Hides the actions while keeping their space, so a route that has no
     * actions doesn't shift the layout. Defaults to visible.
     */
    actionsVisible?: boolean;
    navigation?: ReactNode;
    hiddenOnPhone?: boolean;
}

export function ApplicationBarToolbar({
    actions,
    actionsVisible = true,
    navigation,
    hiddenOnPhone = false,
}: ApplicationBarToolbarProps) {
    const variant = useApplicationBarVariant();

    return (
        <div
            className={cx(
                theme.toolbar[variant],
                hiddenOnPhone && theme.hiddenOnPhone
            )}
        >
            {actions && (
                <div
                    className={cx(
                        theme.actions[variant],
                        !actionsVisible && theme.actionsHidden
                    )}
                >
                    {actions}
                </div>
            )}
            {navigation && (
                <div className={theme.navigation[variant]}>{navigation}</div>
            )}
        </div>
    );
}
